
import Progress from '@/crowd_fund/Progress'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
components: { Progress,Flexbox,TabItem},
props:['zcdata','zcuserid','zctoken','zcnickname','zcheadimgurl','iswxlink'],
data () {
return {
imgUrl:require('../assets/images/gongzhang.png'),
setHeight:document.documentElement.clientWidth*0.92/(750/422)
}
},
methods :{
toThousands(nStr) {
nStr += '';
let x = nStr.split('.');
let x1 = x[0];
let x2 = x.length > 1 ? '.' + x[1] : '';
var rgx = /(\d+)(\d{3})/;
while (rgx.test(x1)) {
x1 = x1.replace(rgx, '$1' + ',' + '$2');
}
return x1 + x2;
},
replaceStr:function(content){
var reg = /习近平班底|中国末代接班群第六代|江泽民|茉莉花革命|习近平|操纵十八大|毛泽东|中共九十年功罪|政权保卫战|枪|法轮功|赖昌星|邓小平|信用卡套现|轻松筹|水滴筹|腾讯公益|爱心筹|骗子|水滴互助|小姐|卖淫/g;
var showC = content.replace(reg,function( $reg ){
var r = '';
for ( var i=0;i<$reg.length;i++ )
{
r += '*';
}
return r;
})
return showC;
},
goQKL (data) {
if(this.isWeixinCient()){
window.location.href=this.QKL_URL+data
}else{
console.log('{"title":"扶贫区块链","url":"'+this.QKL_URL+''+data+'&&platform=app"}');
window.navigation.pushPage('{"title":"扶贫区块链","url":"'+this.QKL_URL+data+'&&platform=app","navbarHidden":"YES"}')
}
},
goDetail () {
var _this = this


console.log(window.location.href,'这是当前跳转详情地址');
if(this.isWeixinCient()){

console.log('这是微信的跳转详情');

console.log('/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken);
if(this.zcdata.crowdId){
this.$router.push('/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken);
}else{
this.$router.push('/zcprojectDetail/'+this.zcdata.crowdid+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken);
}
}else{

if(localStorage.getItem('isdetail') == '1'){
if(this.zcdata.crowdId){
this.$router.push('/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken+'?headImage='+this.zcheadimgurl);
}else{
this.$router.push('/zcprojectDetail/'+this.zcdata.crowdid+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken+'?headImage='+this.zcheadimgurl);
}
}else{
console.log('这是app的跳转详情');
console.log(this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken+'?histroy=black&headImage='+this.zcheadimgurl+'&isProvince='+this.isProvince)

if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
if(this.zcdata.crowdId){
if(_this.$route.query.fromHtml == 1 || _this.$route.query.fromHtml == '1'){

this.$router.push('/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken+'?headImage='+this.zcheadimgurl)
}else{
window.navigation.pushPage('{"title":"项目详情","url":"'+this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken+'?histroy=black&headImage='+this.zcheadimgurl+'","navbarHidden":"YES","type":"2","crowdurl":"'+this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.zcdata.crowdId+'"}');
}
}else{
if(_this.$route.query.fromHtml == 1 || _this.$route.query.fromHtml == '1'){
this.$router.push('/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken+'?headImage='+this.zcheadimgurl)
}else{
window.navigation.pushPage('{"title":"项目详情","url":"'+this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken+'?histroy=black&headImage='+this.zcheadimgurl+'","navbarHidden":"YES","type":"2","crowdurl":"'+this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.zcdata.crowdId+'"}');
}
}
}else{
if(this.zcdata.crowdId){
if(_this.$route.query.fromHtml == 1 || _this.$route.query.fromHtml == '1'){
window.navigation.pushPage('{"title":"项目详情","url":"'+this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken+'?headImage='+this.zcheadimgurl+'","navbarHidden":"YES"}');
}else{
window.navigation.pushPage('{"title":"项目详情","url":"'+this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.zcdata.crowdId+'/'+this.zcuserid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zctoken+'?histroy=black&headImage='+this.zcheadimgurl+'","navbarHidden":"YES"}');
}
}else{
if(_this.$route.query.fromHtml == 1 || _this.$route.query.fromHtml == '1'){
window.navigation.pushPage('{"title":"项目详情","url":"'+this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.zcdata.crowdid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zcuserid+'/'+this.zctoken+'?headImage='+this.zcheadimgurl+'","navbarHidden":"YES"}');

}else{
window.navigation.pushPage('{"title":"项目详情","url":"'+this.appjump_url+'/pages/index/#/zcprojectDetail/'+this.zcdata.crowdid+'/'+encodeURIComponent(this.zcnickname)+'/'+this.zcuserid+'/'+this.zctoken+'?histroy=black&headImage='+this.zcheadimgurl+'","navbarHidden":"YES"}');

}
}
}

}

}
}
},
mounted () {
console.log(this.zcdata)
}
}



// WEBPACK FOOTER //
// ./src/crowd_fund/compentListnew.vue